var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExclamationFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5,0 C16.296,0 21,4.704 21,10.5 C21,16.296 16.296,21 10.5,21 C4.704,21 0,16.296 0,10.5 C0,4.704 4.704,0 10.5,0 Z M9,13.9989566 L9,15.0010434 C9,15.5573397 9.44724809,16 9.99895656,16 L11.0010434,16 C11.5573397,16 12,15.5527519 12,15.0010434 L12,13.9989566 C12,13.4426603 11.5527519,13 11.0010434,13 L9.99895656,13 C9.44266033,13 9,13.4472481 9,13.9989566 Z M9,6.00292933 L9,10.9970707 C9,11.5621186 9.44724809,12 9.99895656,12 L11.0010434,12 C11.5573397,12 12,11.5509732 12,10.9970707 L12,6.00292933 C12,5.43788135 11.5527519,5 11.0010434,5 L9.99895656,5 C9.44266033,5 9,5.44902676 9,6.00292933 Z"
})))));
export default SvgExclamationFill;